import { ArrowRight, Mail } from "lucide-react";
import { Reveal } from "./Reveal";
import { useSite } from "../../context/SiteContext";

const FinalCTA = () => {
  const { openBooking, scrollToId } = useSite();
  return (
    <section className="relative overflow-hidden bg-gradient-to-r from-brand-navy via-[#2530A8] to-brand-sky py-24 md:py-32 grain" data-testid="final-cta-section">
      <div className="absolute -top-24 left-1/4 w-96 h-96 rounded-full bg-white/10 blur-3xl" />
      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <Reveal>
          <h2 className="font-display text-4xl md:text-6xl font-bold tracking-tight text-white leading-[1.08]" data-testid="final-cta-headline">
            Ready to Spend More Time With Patients?
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-6 text-base md:text-lg text-white/80 leading-relaxed max-w-2xl mx-auto">
            Book a discovery call today and see how Virtual Live Human Medical Scribing can transform your practice.
          </p>
        </Reveal>
        <Reveal delay={0.22}>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <button
              data-testid="final-cta-book-button"
              onClick={openBooking}
              className="group inline-flex items-center gap-2.5 rounded-full bg-white text-brand-navy font-bold px-9 py-4 text-sm hover:shadow-[0_20px_50px_-15px_rgba(255,255,255,0.5)] hover:-translate-y-0.5 transition-[transform,box-shadow] duration-300"
            >
              Book Discovery Call
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform duration-300" />
            </button>
            <button
              data-testid="final-cta-contact-button"
              onClick={() => scrollToId("contact")}
              className="inline-flex items-center gap-2.5 rounded-full border-2 border-white/50 text-white font-bold px-9 py-4 text-sm hover:bg-white/10 transition-colors duration-300"
            >
              <Mail size={16} />
              Contact Us
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
export default FinalCTA;
